import WidgetAreeTematiche from './WidgetAreeTematiche';

export default WidgetAreeTematiche;
